export default __webpack_public_path__ + "static/media/wrong-dark.81038b8f.svg";